export const DELIVERY_TYPE_META = {
  0: { icon: "mdi-motorbike", labelKey: "delivery_to_address" },
  1: { icon: "mdi-silverware-fork-knife", labelKey: "pickup" },
  2: { icon: "mdi-home", labelKey: "consumption_in_restaurant" },
};

export const STATUS_COLORS = {
  pending: "#1e88e5",
  accepted: "#f9a825",
  "in-progress": "#f9a825",
  ready: "#e53935",
  "on-hold": "#757575",
  delivered: "#43a047",
  completed: "#43a047",
  cancelled: "#b71c1c",
};

// "accepted" and "in-progress" are merged into a single "preparing" column
// (both shown as "U pripremi"), so advancing from "accepted" skips straight
// to "ready" - going to "in-progress" first would be an invisible step since
// the ticket wouldn't visibly move or relabel.
export const NEXT_STATUS = {
  pending: "accepted",
  accepted: "ready",
  "in-progress": "ready",
  "on-hold": "accepted",
};

export const ACTIVE_STATES = [
  "pending",
  "accepted",
  "in-progress",
  "ready",
  "on-hold",
  "delivered",
  "completed",
];

// Full list of statuses an order can be manually switched to from the
// per-ticket status menu, in menu display order.
export const ORDER_STATUSES = [
  { value: "pending", icon: "mdi-clock-outline" },
  { value: "accepted", icon: "mdi-check" },
  { value: "in-progress", icon: "mdi-progress-clock" },
  { value: "ready", icon: "mdi-food" },
  { value: "on-hold", icon: "mdi-pause" },
  { value: "delivered", icon: "mdi-truck-check" },
  { value: "completed", icon: "mdi-check-all" },
  { value: "cancelled", icon: "mdi-cancel" },
];

// The kitchen workflow groups, in left-to-right board order.
// "on-hold" shares the same "Na čekanju" label as "pending" so it belongs in
// the pending group, not preparing - preparing is strictly accepted/in-progress.
// "completed" is split out from "delivered" as its own opt-in column (hidden
// by default - see loadVisibleGroups in kitchen-display.vue).
export const KDS_GROUPS = [
  {
    key: "pending",
    states: ["pending", "on-hold"],
    icon: "mdi-receipt-text-outline",
    accent: STATUS_COLORS.pending,
    labelKey: "kds_new_orders",
  },
  {
    key: "preparing",
    states: ["accepted", "in-progress"],
    icon: "mdi-pot-steam-outline",
    accent: STATUS_COLORS["in-progress"],
    labelKey: "in-progress",
  },
  {
    key: "ready",
    states: ["ready"],
    icon: "mdi-food-takeout-box-outline",
    accent: STATUS_COLORS.ready,
    labelKey: "ready",
  },
  {
    key: "delivered",
    states: ["delivered"],
    icon: "mdi-truck-check",
    accent: STATUS_COLORS.delivered,
    labelKey: "delivered",
  },
  {
    key: "completed",
    states: ["completed"],
    icon: "mdi-check-all",
    accent: STATUS_COLORS.completed,
    labelKey: "completed",
  },
];

export const DENSITY_OPTIONS = ["full", "compact", "minimal"];

// Quick-pick prep time options (in minutes) offered when accepting a new
// order, so staff can log an estimate in a single click instead of typing it.
export const KDS_PREP_TIME_OPTIONS = [5, 10, 15, 20, 30, 45];

export function toISODate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function groupForState(state) {
  const group = KDS_GROUPS.find((g) => g.states.includes(state));
  return group ? group.key : null;
}

// Blends a "#rrggbb" accent color into a "#rrggbb" base color by the given
// ratio (0 = pure base, 1 = pure accent), returning a solid "#rrggbb" color.
// Used to tint the page background based on the currently selected status
// tab without introducing any transparency/gradient.
export function mixHexColors(baseHex, accentHex, ratio) {
  const base = baseHex.replace("#", "");
  const accent = accentHex.replace("#", "");
  const mixChannel = (start, end) =>
    Math.round(start + (end - start) * ratio)
      .toString(16)
      .padStart(2, "0");

  const r = mixChannel(parseInt(base.substring(0, 2), 16), parseInt(accent.substring(0, 2), 16));
  const g = mixChannel(parseInt(base.substring(2, 4), 16), parseInt(accent.substring(2, 4), 16));
  const b = mixChannel(parseInt(base.substring(4, 6), 16), parseInt(accent.substring(4, 6), 16));

  return `#${r}${g}${b}`;
}
